import React from "react";
import { Controller } from "react-hook-form";
import { FormControl, InputLabel, MenuItem, Select, Box } from "@material-ui/core";
import { useDockerManagementContext } from "../../DockerManagementProvider";

export default function DeviceModeFormField({ control, errors }) {
	const { state: { chipsets } } = useDockerManagementContext();
	return (
		<Box display="flex">
			<Box flexGrow={1}>
				<FormControl fullWidth>
					<InputLabel shrink={true}>Hardware Type</InputLabel>
					<Controller
						name="chipset"
						control={control}
						render={({ field }) => (
							<Select
								{...field}
								defaultValue=""
								placeholder="Select a device chipset..."
								fullWidth
								error={!!errors.chipsets}>
								{chipsets.map(s => {
									return <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
								})}
							</Select>
						)}
					/>
				</FormControl>
			</Box>
		</Box>
	);
}